import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-center overflow-hidden" }
const _hoisted_2 = { class: "text-center overflow-hidden" }

import { ref, onMounted,computed } from 'vue';
import { data } from '../composables/useData';
import { method } from '../composables/useMethod';
import GetAccessToken from './GetAccessToken.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsPage',
  setup(__props) {

const filterdProperties = computed(() => {
  return data.loginUser.reports.selectProperties.filter(item => data.loginUser.reports.properties.find(property => property.account === item.account));
});
  




return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_expansion_panels, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_expansion_panel, {
          title: "基本設定",
          color: "info"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panel_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(data).loginUser.name) + " ", 1),
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(data).loginUser.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).loginUser.name) = $event)),
                      label: "名前",
                      "prepend-inner-icon": "mdi-help-circle",
                      "onClick:prependInner": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showHint('名前')))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(data).loginUser.email,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).loginUser.email) = $event)),
                      label: "メールアドレス",
                      "prepend-inner-icon": "mdi-help-circle",
                      "onClick:prependInner": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showHint('メールアドレス')))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      onClick: _ctx.changePassword,
                      disabled: _unref(data).disabled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("パスワード変更")
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode(_component_v_btn, {
                      color: "secondary",
                      disabled: _unref(data).disabled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存する")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_expansion_panel, {
          title: "顧客設定",
          color: "info"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panel_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(method).endUser.create())),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新規顧客作成")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_text_field, {
                  modelValue: _unref(data).loginUser.endUser.name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(data).loginUser.endUser.name) = $event)),
                  placeholder: "お名前"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: _unref(data).loginUser.endUser.email,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(data).loginUser.endUser.email) = $event)),
                  placeholder: "メールアドレス"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_divider, { class: "my-4" }),
                _createVNode(_component_v_btn, {
                  color: "secondary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(method).endUser.saveUseProperties())),
                  disabled: _unref(data).disabled
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存する")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).loginUser.endUser.list, (user) => {
                  return (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: user.uid
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel, {
                        title: user.name
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(data).dialog.endUserAnalytics = true))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("表示レポート設定")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(data).dialog.endUserMailText = true))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("送信メール本文設定")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_btn, {
                                color: "error",
                                onClick: ($event: any) => (_unref(method).endUser.delete(user.uid)),
                                disabled: _unref(data).disabled
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("アカウント削除")
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_dialog, {
                            modelValue: _unref(data).dialog.endUserAnalytics,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(data).dialog.endUserAnalytics) = $event)),
                            width: "500"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).loginUser.reports.accounts, (account) => {
                                    return (_openBlock(), _createBlock(_component_v_expansion_panels, {
                                      key: account.name
                                    }, {
                                      default: _withCtx(() => [
                                        (account.properties)
                                          ? (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                              key: 0,
                                              title: account.displayName
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_expansion_panel_text, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_card, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_card_text, null, {
                                                          default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(account.properties, (property) => {
                                                              return (_openBlock(), _createBlock(_component_v_checkbox, {
                                                                key: property.name,
                                                                modelValue: user.useProperties,
                                                                "onUpdate:modelValue": ($event: any) => ((user.useProperties) = $event),
                                                                label: property.displayName,
                                                                value: property
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "value"]))
                                                            }), 128))
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["title"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["modelValue"]),
                          _createVNode(_component_v_dialog, {
                            modelValue: _unref(data).dialog.endUserMailText,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(data).dialog.endUserMailText) = $event)),
                            width: "500"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: user.mailText.subject,
                                        "onUpdate:modelValue": ($event: any) => ((user.mailText.subject) = $event),
                                        label: "タイトル"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_v_textarea, {
                                        modelValue: user.mailText.firstHalf,
                                        "onUpdate:modelValue": ($event: any) => ((user.mailText.firstHalf) = $event),
                                        label: "前半部"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_v_textarea, {
                                        modelValue: user.mailText.secondHalf,
                                        "onUpdate:modelValue": ($event: any) => ((user.mailText.secondHalf) = $event),
                                        label: "後半部"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_v_textarea, {
                                        modelValue: user.mailText.signature,
                                        "onUpdate:modelValue": ($event: any) => ((user.mailText.signature) = $event),
                                        label: "署名"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_actions, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        color: "secondary",
                                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(method).endUser.save()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("保存する")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["title"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_expansion_panel, {
          title: "アナリティクス設定",
          color: "info"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panel_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(method).google.getGoogleAnalyticsAccounts(),_unref(data).google.dialog = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("プロパティの再取得")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "secondary",
                  onClick: _unref(method).settings.save.properties
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存する")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).loginUser.reports.accounts, (account) => {
                  return (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: account.name
                  }, {
                    default: _withCtx(() => [
                      (account.properties)
                        ? (_openBlock(), _createBlock(_component_v_expansion_panel, {
                            key: 0,
                            title: account.displayName
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_text, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(account.properties, (property) => {
                                            return (_openBlock(), _createBlock(_component_v_checkbox, {
                                              key: property.name,
                                              modelValue: _unref(data).loginUser.reports.selectProperties,
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(data).loginUser.reports.selectProperties) = $event)),
                                              label: property.displayName,
                                              value: property
                                            }, null, 8, ["modelValue", "label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(data).dialog.analyticsPreference,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(data).dialog.analyticsPreference) = $event)),
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (!_unref(data).loginUser.reports.accounts.length)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        color: "primary",
                        indeterminate: "",
                        size: 54
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_unref(data).loginUser.reports.accounts.length)
                  ? (_openBlock(), _createBlock(GetAccessToken, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(data).google.dialog,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(data).google.dialog) = $event)),
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (!_unref(data).loginUser.reports.accounts.length)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        color: "primary",
                        indeterminate: "",
                        size: 54
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_unref(data).loginUser.reports.accounts.length)
                  ? (_openBlock(), _createBlock(GetAccessToken, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})